import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { User, UserInformation } from '../_model/index';
import { environment } from '../../environments/environment';
import { Subject, Observable } from 'rxjs';
import {Router ,ActivatedRoute, NavigationEnd, Event, NavigationStart, NavigationError} from '@angular/router';

@Injectable()
export class AuthenticationService {
    user: User;
    userCheck: any;
    logoutValue: string;
    logoutSuccess: boolean;
    constructor(private http: HttpClient, private router: Router, private activatedRoute: ActivatedRoute) {
        this.user = new User();
        document.addEventListener("visibilitychange", function () {
            if (document.hidden) {
                window.localStorage.setItem('pageActive', "false")
            }
            else {
                window.localStorage.setItem('pageActive', "true")
            }

        });
        window.addEventListener('storage', () => {
            let pageActive = window.localStorage.getItem('pageActive');
            this.userCheck = window.localStorage.getItem(this.getCurrentUserVar());
            this.logoutValue = window.localStorage.getItem('logoutValue' + this.getCurrentUrl());
            if (this.logoutValue === "true") {
                if (this.userCheck == null || this.userCheck == undefined && pageActive === "false") {
                    window.localStorage.setItem('logoutValue' + this.getCurrentUrl(), "false");
                    // let isSamlLogin = localStorage.getItem('isSamlLogin');
                    let isSamlLogin = this.getValueInConfigFromLocalStorage('isSamlLogin');
                    // let samlLogoutUrl = localStorage.getItem('samlLogoutUrl');
                    let samlLogoutUrl = this.getValueInConfigFromLocalStorage('samlLogoutUrl');
                    let isCasLogin = this.getValueInConfigFromLocalStorage('isCasLogin');
                    let casLogoutUrl = this.getValueInConfigFromLocalStorage('casLogoutUrl');
                    let casRedirectUrl = this.getValueInConfigFromLocalStorage('casRedirectUrl');
                    if (isSamlLogin === 'true') {
                        // localStorage.removeItem('isSamlLogin');
                        this.removeValueInConfigAtLocalStorage('isSamlLogin');
                        if (samlLogoutUrl !== null) {
                            localStorage.removeItem('samlLogoutUrl');
                            window.location.replace(samlLogoutUrl);
                        } else {
                            this.router.navigate([this.getCurrentUrl(), 'home']);
                        }
                    } else if (isCasLogin == 'true') {
                        this.removeValueInConfigAtLocalStorage('isCasLogin');
                        if (casRedirectUrl !== null) {
                            localStorage.removeItem('casRedirectUrl');
                            localStorage.removeItem('casLogoutUrl');
                            window.location.replace(casRedirectUrl);
                        } else if (casLogoutUrl !== null) {
                            localStorage.removeItem('casRedirectUrl');
                            localStorage.removeItem('casLogoutUrl');
                            window.location.replace(casLogoutUrl);
                        } else {
                            this.router.navigate([this.getCurrentUrl(), 'home']);
                        }
                    } else {
                        this.router.navigate([this.getCurrentUrl(), 'login']);
                    }
                }
            }
        });
    }

     newPassword(sid, pwd, confirmPassword:string,instId:string): Observable<any> { 
        const newPasswordURL = environment.reset+instId;
        let data = {
            sid: sid,
            newPassword: pwd
        }
        return this.http.put(newPasswordURL, data)
        .pipe(map((user: any) => {
                return user;
            }));
      }
    login(username: string, password: string, instId: string, loginType: string) {
        this.user.username = username;
        this.user.password = password;
        const loginURL =  environment.login + instId;
        return this.http.post(loginURL, {client: '',
        password,
        username,
        loginType})
        .pipe(tap(user => console.log("USER1:", user)),map((user: any) => {
                // login successful if there's a jwt token in the response
                // if (user && user.return_body) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    console.log("USER:",user);
                    // let isSamlLogin = localStorage.getItem('isSamlLogin');
                    // if (isSamlLogin !== 'true') {
                    //     this.setCurrentUserPK(user.return_body.user.pk); 
                    // }
                    this.setCurrentUserName(username);
                    let currentUser : UserInformation = user.return_body;
                    this.setCurrentUser(JSON.stringify(currentUser));
                    console.log("CURRENT USER",JSON.stringify(user.return_body));
                // }
                return user;
            }));
    }
    validateResetToken(sid: string,instId:string) {
        const validateTokenURL =  environment.valitateToken + '/' + instId + '?sid=' + sid;
        return this.http.get(validateTokenURL).pipe(map((res:any)=>{
            return res;
        }));
    }

    forgotPwdReset(columnType:string,userValue:string,instId: string){
        const loginURL =  environment.dbForogtPwdReset + instId;
        return this.http.post(loginURL, {columnType,userValue})
        .pipe(map((user: any) => {
                return user;
            }));
    }

    tokenRefresh(){
        const refreshURL = environment.refreshToken;
        return this.http.get(refreshURL).pipe(map((user: any) => {
            // refresh token successful if there's a jwt token in the response
            if (user && user.return_body && user.return_code == 200) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                // localStorage.setItem('currentUser'+this.getCurrentUrl(), JSON.stringify(user.return_body));
                let currentUser = JSON.parse(this.getCurrentUser());
                currentUser['expiredTime'] = user.return_body['expiredTime'];
                currentUser['token'] = user.return_body['token'];
                this.setCurrentUser(JSON.stringify(currentUser));
            } else {
                console.log('Token is invalid - Please login again');
                this.logout();
            }
            return user;
        }));
    }

    logout() {
        if (this.isUserLoggedIn()) {
            this.deleteBearerToken().subscribe(()=>{
                console.log('bearer token deleted from active shp session ')
            });        

            let currentRoute = this.router.url.split('/');
            if (currentRoute[2] !== "login") {
                window.localStorage.setItem('logoutValue' + this.getCurrentUrl(), "true");
            }

            let isSamlLogin = this.getValueInConfigFromLocalStorage('isSamlLogin');
            let isCasLogin = this.getValueInConfigFromLocalStorage('isCasLogin');
            if (isSamlLogin === 'true') {
                // localStorage.removeItem('isSamlLogin');
                // let samlLogoutUrl = localStorage.getItem('samlLogoutUrl');
                let samlLogoutUrl = this.getValueInConfigFromLocalStorage('samlLogoutUrl');

                if (samlLogoutUrl !== null && samlLogoutUrl !== undefined) {
                    this.removeLocalStorageItems();
                    window.location.replace(samlLogoutUrl);
                }
                else {
                    this.removeLocalStorageItems();
                    // this.removeValueInConfigAtLocalStorage('allowModifyPwd');
                    this.router.navigate([this.getCurrentUrl(), 'home']);
                }
            } else if (isCasLogin === 'true') {
                let casLogoutUrl = this.getValueInConfigFromLocalStorage('casLogoutUrl');
                let casRedirectUrl = this.getValueInConfigFromLocalStorage('casRedirectUrl');
                if (casRedirectUrl && casRedirectUrl !== null && casRedirectUrl !== undefined) {
                    this.removeLocalStorageItems();
                    window.location.replace(casRedirectUrl);
                }
                else if (casLogoutUrl && casLogoutUrl !== null && casLogoutUrl !== undefined) {
                    this.removeLocalStorageItems();
                    // localStorage.removeItem('samlLogoutUrl');
                    window.location.replace(casLogoutUrl);
                }
                else {
                    this.removeLocalStorageItems();
                    // this.removeValueInConfigAtLocalStorage('allowModifyPwd');
                    this.router.navigate([this.getCurrentUrl(), 'home']);
                }
            } else {
                this.removeLocalStorageItems();
                // this.removeValueInConfigAtLocalStorage('allowModifyPwd');
                this.router.navigate([this.getCurrentUrl(), 'login']);
            }
        }
    }

    deleteBearerToken(){
        return this.http.delete(environment.deleteToken);
    }

    isUserLoggedIn() {
        let userData: UserInformation = JSON.parse(this.getCurrentUser());
        return (userData !== null && userData.user !== null);
    }

    isSessionTimeOut() {
        let status = localStorage.getItem('sessionTimeOut');
        localStorage.removeItem('sessionTimeOut');
        return !(status === null);
    }

    //CURRENT USER
    getCurrentUserVar() {
        return 'currentUser' + this.getCurrentUrl();
    }

    getCurrentUser() {
        var cs = this.getCurrentUserVar();
        return localStorage.getItem(this.getCurrentUserVar());
    }

    setCurrentUser(user) {
        localStorage.setItem(this.getCurrentUserVar(), user);
    }

    removeCurrentUser() {
        localStorage.removeItem(this.getCurrentUserVar());
    }

    //CURRENT USER NAME
    getCurrentUserNameVar() {
        return 'userName' + this.getCurrentUrl();
    }

    getCurrentUserName() {
        return localStorage.getItem(this.getCurrentUserNameVar());
    }

    setCurrentUserName(userName) {
        localStorage.setItem(this.getCurrentUserNameVar(), userName);
    }

    removeCurrentUserName() {
        localStorage.removeItem(this.getCurrentUserNameVar());
    }

    //PK
    // getCurrentUserPKVar(){
    //     return 'pk' + this.getCurrentUrl(); //this.user.username
    // }

    // getCurrentUserPK(){
    //     return localStorage.getItem(this.getCurrentUserPKVar());
    // }

    // setCurrentUserPK(pk){
    // localStorage.setItem(this.getCurrentUserPKVar(), pk);
    // }

    // removeCurrentUserPK(){
    // localStorage.removeItem(this.getCurrentUserPKVar());
    // }

    // getCurrentUserPK(){
    //     var data = JSON.parse(this.getCurrentUser());
    //     return data.user.pk;
    // }

    getCurrentUserPK(){
        var data = JSON.parse(this.getCurrentUser());
        if (data !== null && data.user !== null && data.user.pk !== null) {
            return data.user.pk;
        }
        return null;
    }

    //CURRENT URL
    getCurrentUrl(){
        return  this.router.url.split('/')[1];
    }
    
    //LAST TIME VISITED
    getLastTimeVisitedVar(){
    return 'lastVisitTime' + this.getCurrentUrl();
    }

    setLastTimeVisited(time){
    localStorage.setItem(this.getLastTimeVisitedVar(), time);
    }

    getLastVisitTime(){
    return localStorage.getItem(this.getLastTimeVisitedVar());
    }

    removeLastVisitTime(){
    localStorage.removeItem(this.getLastTimeVisitedVar());
    }

    //CONFIG
    getConfig(){
        return 'config' + this.getCurrentUrl();
    }

    //TIME OUT

    getTimeOutVar(){
        return 'isTimeOut' + this.getCurrentUrl();
     }

    setTimeOut(timeout){
       localStorage.setItem(this.getTimeOutVar(), timeout);
    }

    getTimeOut(){
       return localStorage.getItem(this.getTimeOutVar());
    }

    removeTimeOut(){
        localStorage.removeItem(this.getTimeOutVar());
    }

    //TICKET 
    getTicketVar(){
        return 'ticket' + this.getCurrentUrl();
    }

    setTicket(timeout){
        localStorage.setItem(this.getTicketVar(), timeout)
     }
 
     getTicket(){
        
        return localStorage.getItem(this.getTicketVar());
     }
 
     removeTicket(){
         var cs= this.getTicketVar();
         localStorage.removeItem(this.getTicketVar());
     }
    //  //isChatOn
    // getChatOnVar(){
    //     return 'isChatOn';
    // }
    // setChatOn(chatOn){
    //     localStorage.setItem(this.getChatOnVar(),chatOn)
    // }
    // getChaton(){
    //   return localStorage.getItem(this.getChatOnVar())
    // }
    //autoOpenChatWindow
    // getAutoOpenChatWindowVar(){
    // return 'autoOpenChatWindow';
    // }
    // setAutoOpenChatWindow(autoChat){
    // localStorage.setItem(this.getAutoOpenChatWindowVar(),autoChat)
    // }
    // getAutoOpenChatWindow(){
    // return localStorage.getItem(this.getAutoOpenChatWindowVar())
    // }

     //Remove All
     removeLocalStorageItems(){
      this.removeCurrentUser();
      this.removeCurrentUserName();
      this.removeTicket();
      this.removeTimeOut();
    //   this.removeCurrentUserPK();
     }

     removeChatValues() {
        //  localStorage.removeItem('autoOpenChatWindow');
        //  localStorage.removeItem('isChatOn');
         this.removeValueInConfigAtLocalStorage('autoOpenChatWindow');
         this.removeValueInConfigAtLocalStorage('isChatOn');
     }

     /* 
        *   Store and Retreive Institution Specfic values in Local Storage 
        *   This approach helps to avoid overlap of values for multiple insts in different browser tabs
     */
     getConfigFromLocalStorage() {
        return JSON.parse(localStorage.getItem('config' + this.getCurrentUrl()));
    }
    getTitleFromLocalStorage() {
        return localStorage.getItem('title');
    }
    setTitleAtLocalStorage(titles) {
        localStorage.setItem('title',titles);
    }

    setConfigAtLocalStorage(config) {
        localStorage.setItem('config' + this.getCurrentUrl(), JSON.stringify(config));
    }

    getValueInConfigFromLocalStorage(key) {
        let config = this.getConfigFromLocalStorage();
        return config !== null && config[key] !== null ? config[key] : null;
    }

    setValueInConfigAtLocalStorage(key, value) {
        let config = this.getConfigFromLocalStorage();
        if (config === null) {
            config = {};
            config[key] = value;
        } else {
            config[key] = value;
        }
        this.setConfigAtLocalStorage(config);
    }

    removeValueInConfigAtLocalStorage(key) {
        let config = this.getConfigFromLocalStorage();
        config[key] = null;
        this.setConfigAtLocalStorage(config);
    }

}
